{
  "(optional)": "(opcional)",
  "(required)": "(necesario)"
}